import React from "react";
import { ExternalLink, FileText } from "lucide-react";
import { SPONSOR_LINKS } from "@/lib/lenses";

export default function SponsorBanner() {
  return (
    <div
      data-testid="sponsor-banner"
      className="relative overflow-hidden rounded-2xl border border-sky-900/40 shadow-sm"
      style={{
        background:
          "linear-gradient(120deg, #0B192C 0%, #0F2A44 45%, #0369A1 100%)",
      }}
    >
      <div className="absolute inset-0 opacity-20 mix-blend-overlay pointer-events-none"
           style={{ backgroundImage: "radial-gradient(circle at 90% 10%, rgba(255,255,255,0.5) 0px, transparent 40%)" }} />
      <div className="relative flex flex-col sm:flex-row items-start sm:items-center gap-4 px-6 py-5 text-white">
        <div className="flex items-center gap-3">
          <div className="text-[10px] uppercase tracking-[0.22em] text-sky-200 font-semibold border border-sky-300/30 rounded-full px-3 py-1">
            Clinical Sponsor
          </div>
        </div>
        <a
          href={SPONSOR_LINKS.product}
          target="_blank"
          rel="noopener noreferrer sponsored"
          className="flex-1 min-w-0 group"
          data-testid="sponsor-link"
        >
          <div className="font-serif text-xl sm:text-2xl font-semibold tracking-tight group-hover:underline decoration-sky-300/60 underline-offset-4">
            Cristalens Artis Symbiose<sup className="text-xs">®</sup>
            <span className="ml-2 text-sky-200 text-sm font-normal">Preloaded Binocular EDOF IOL</span>
            <ExternalLink className="inline-block w-4 h-4 ml-2 opacity-60 group-hover:opacity-100 transition-opacity" />
          </div>
          <div className="text-sm text-sky-100/90 mt-1">
            Mid & Plus complementary phase technology · Continuous vision 40 cm → infinity · Toric with posterior
            corneal astigmatism ready · A-constant <span className="font-mono">119.84</span> (Barrett) ·{" "}
            <span className="font-mono">119.74</span> (other) · SIA <span className="font-mono">0.20 D @ 180°</span> temporal
          </div>
        </a>
        <a
          href={SPONSOR_LINKS.brochure}
          target="_blank"
          rel="noopener noreferrer sponsored"
          className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-white text-sky-900 px-4 py-2 text-sm font-semibold hover:bg-sky-50 transition"
          data-testid="sponsor-cta"
        >
          <FileText className="w-4 h-4" /> Optical Specs (PDF)
        </a>
      </div>
    </div>
  );
}
